import React, { Fragment } from 'react';

import Button from '../../../../../../../../components/global/Button';
import useOpenModal from '../../../../../../../../hooks/useOpenModal';
import CheckmarkIcon from '../../../../../../../../components/icons/CheckmarkIcon';
import { EVENT_ADDON_ITEM_INFORMATION } from '../../../../../../components/FreemiumEventPurchase/components/EventAddonItemInformationModal';
import InfoCircleIcon from '../../../../../../../../components/icons/InfoCircleIcon';
import { WALDOFICATION_FEATURES } from '../constants';
import { WALDOFIED_FEATURE_COMPARISON } from '../../../../../../components/FreemiumEventPurchase/components/WaldofiedFeatureComparisonModal';
import ArrowRight from '../../../../../../../../components/icons/ArrowRight';

const VariantA = () => {
  const openModal = useOpenModal();

  return (
    <Fragment>
      <p className="text-light text-normal text-base mt-2">
        Gold galleries are packed with all these amazing premium features:
      </p>
      <ul className="list-style-none mt-1 pl-0 text-dark">
        {WALDOFICATION_FEATURES.map(feature => (
          <li key={feature?.id ?? feature} className="mb-1">
            <CheckmarkIcon
              color="#f1794e"
              size="14px"
              className="feature-icon"
            />{' '}
            <span>{feature?.label ?? feature}</span>
            {feature?.howItWorks && (
              <Button
                btnStyle="reset"
                onClick={() => {
                  openModal(EVENT_ADDON_ITEM_INFORMATION, {
                    title: feature.label,
                    ...feature?.howItWorks,
                  });
                }}
                className="ml-1"
              >
                <InfoCircleIcon size={14} />
              </Button>
            )}
            {feature?.detail && (
              <span className="d-block d-md-inline-block ml-2 ml-md-1 text-xs text-light">
                {feature.detail}
              </span>
            )}
          </li>
        ))}
      </ul>
      <Button
        btnSize="sm"
        btnStyle="link"
        onClick={() => openModal(WALDOFIED_FEATURE_COMPARISON)}
        className="mb-2 mr-auto"
      >
        Compare with free{' '}
        <ArrowRight color="#0d84fe" size={12} className="ml-1" />
      </Button>
    </Fragment>
  );
};

export default VariantA;
